import { render } from "./formula.vue?vue&type=template&id=948d5f8a&lang=pug"
import script from "./formula.vue?vue&type=script&lang=js"
export * from "./formula.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__